import React from "react";
import { FiSearch, FiX } from "react-icons/fi";

export default function RechercheSearchBox({
  term,
  onTerm,
  onSubmit,
  onClear,
  loading,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6"
    >
      <label
        htmlFor="global-search"
        className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400"
      >
        Recherche globale
      </label>

      <div className="mt-3 flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <FiSearch className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />

          <input
            id="global-search"
            type="search"
            value={term}
            onChange={(event) => onTerm(event.target.value)}
            placeholder="Ex. urbanisme, judo, conseil municipal, déchets, état civil…"
            className="h-14 w-full rounded-2xl border border-slate-200 bg-white pl-12 pr-12 text-sm font-semibold text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-[#1277B9] focus:ring-4 focus:ring-[#1277B9]/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500"
          />

          {term && (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-3 top-1/2 inline-flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-slate-900 dark:hover:text-white"
              aria-label="Effacer la recherche"
            >
              <FiX className="h-4 w-4" />
            </button>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="inline-flex min-h-14 items-center justify-center gap-2 rounded-2xl bg-[#1277B9] px-6 text-sm font-bold text-white shadow-sm transition hover:bg-[#0f659d] disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FiSearch className="h-4 w-4" />
          {loading ? "Recherche…" : "Rechercher"}
        </button>
      </div>

      <p className="mt-3 text-xs font-semibold text-slate-500 dark:text-slate-400">
        La recherche se lance automatiquement après la saisie.
      </p>
    </form>
  );
}